class CustomDetailsModal extends HTMLElement {
    constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.contentElement = this.detailsContainer.querySelector('.modal___content');
    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }
  }

  connectedCallback() {
    this.bodyContainer = this.createBodyContainer();
    this.bodyContainer.__modal__ = this;
    this.bodyContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    const closeBtns = this.bodyContainer.querySelectorAll('button[name="close"]');
    if (closeBtns.length) {
      closeBtns.forEach((btn) =>
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        }),
      );
    }
  }

  disconnectedCallback() {
    const { bodyContainer, detailsContainer } = this;
    if (bodyContainer !== detailsContainer) {
      bodyContainer.parentNode.removeChild(this.bodyContainer);
    }
  }

  get container() {
    const selector = this.getAttribute('container');
    return selector ? document.querySelector(selector) : undefined;
  }

  get isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  get disabledBodyClickClose() {
    return this.detailsContainer.hasAttribute('disabled-body-click-close');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.summaryToggle.hasAttribute('disabled')) return;
    this.isOpen ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (event.target.classList.contains('modal___overlay')) {
      this.close(event);
    }
  }

  doAnimate(isClose = false) {
    let timer;

    return new Promise((resolve) => {
      const onAnimationend = (event) => {
        if (event && event.target !== this.contentElement) return;
        this.contentElement.removeAttribute('style');
        this.contentElement.removeEventListener('animationend', onAnimationend);
        resolve(this);
        clearTimeout(timer);
      };

      requestAnimationFrame(() => {
        if (isClose) {
          this.contentElement.style.animationDirection = 'reverse';
        }

        this.contentElement.style.animationName = 'var(--modal-animation-name, fadeIn)';
        this.contentElement.addEventListener('animationend', onAnimationend);
        timer = setTimeout(onAnimationend, 300);
      });
    });
  }

  createBodyContainer() {
    const { container, detailsContainer, summaryToggle } = this;

    if (!container) return detailsContainer;

    const bodyContainer = detailsContainer.cloneNode(false);
    const summary = document.createElement('summary');
    bodyContainer.appendChild(summary);
    Array.from(detailsContainer.children).forEach((node) => {
      if (node !== summaryToggle) {
        detailsContainer.removeChild(node);
        bodyContainer.appendChild(node);
      }
    });
    bodyContainer.setAttribute('data-clone', true);
    container.appendChild(bodyContainer);

    return bodyContainer;
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    this.bodyContainer.setAttribute('open', true);
    if (!this.disabledBodyClickClose) {
      this.bodyContainer.addEventListener('click', this.onBodyClickEvent);
    }

    document.body.classList.add('overflow-hidden');

    return this.doAnimate();
  }

  close() {
    if (!this.isOpen) return Promise.resolve();

    return this.doAnimate(true).then((res) => {
      this.detailsContainer.removeAttribute('open');
      this.bodyContainer.removeAttribute('open');
      if (!this.disabledBodyClickClose) {
        this.bodyContainer.removeEventListener('click', this.onBodyClickEvent);
      }
      document.body.classList.remove('overflow-hidden');

      return res;
    });
  }
}

customElements.define('custom-details-modal', CustomDetailsModal);